import styled from 'styled-components';
import { caption, colors, spacing } from 'ui/theme';
import { Tooltip } from 'ui/tooltip';

import { Organization, Project } from '../types';

const MAX_PROJECT_DISPLAY_NAME_LENGTH = 100;

export const SubheadingList = styled.ul`
  all: unset;
  display: flex;
  flex-wrap: wrap;
`;

export const SubheadingItem = styled.li`
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;

  ${caption}
  white-space: nowrap;
  color: ${colors.textSecondary};

  &:not(:last-child):after {
    content: "•";
    padding: 0 ${spacing.quarter};
  }
`;

export const ProjectSettingsSubheading = ({
  project = {} as Project,
  organization = {} as Organization,
}: {
  project: Project;
  organization: Organization;
}) => {
  const { id: projectId, name: projectName } = project;
  const { id: orgId, name: orgName } = organization;

  const isProjectNameTruncated = projectName?.length > MAX_PROJECT_DISPLAY_NAME_LENGTH;

  const truncatedProjectName = isProjectNameTruncated
    ? projectName.slice(0, MAX_PROJECT_DISPLAY_NAME_LENGTH - 3) + '...'
    : projectName;

  const hasOrgInfo = !!orgName && !!orgId;
  const hasProjectInfo = !!projectName && !!projectId;

  return (
    <SubheadingList data-test="project-settings-subheading">
      {hasOrgInfo && (
        <SubheadingItem data-test="organization">{`${orgName} (Org ID: ${orgId})`}</SubheadingItem>
      )}
      {hasProjectInfo && (
        <SubheadingItem data-test="project">
          <span>
            <Tooltip isUnderlined tooltipContent={projectName} isEnabled={isProjectNameTruncated}>
              {truncatedProjectName}
            </Tooltip>
            &nbsp;{`(Project ID: ${projectId})`}
          </span>
        </SubheadingItem>
      )}
    </SubheadingList>
  );
};
